import { Route, Switch } from 'quartz-routing/react-router';
import DataPrivacyRequestContainer from '../containers/DataPrivacyRequestContainer';
import { MissingSlug } from '../containers/MissingSlug';
import VerifyContainer from '../containers/VerifyContainer';
import PreviewContainer from '../containers/PreviewContainer';

/*
 * If adding a new route make sure the configEarlyRequest is skipped
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Paths = {
  DATA_PRIVACY_REQUEST_CONTAINER: '/:slug',
  MISSING_SLUG: '/',
  VERIFY: '/verify/:token',
  PREVIEW: '/preview'
};
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    path: Paths.PREVIEW,
    exact: true,
    component: PreviewContainer
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.DATA_PRIVACY_REQUEST_CONTAINER,
    exact: true,
    component: DataPrivacyRequestContainer
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.MISSING_SLUG,
    exact: true,
    component: MissingSlug
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.VERIFY,
    component: VerifyContainer
  })]
});